const targets = [
  "慢性的な肩こり・腰痛に悩んでいる方",
  "仕事のストレスで心身が疲弊している方",
  "睡眠の質を改善したい方",
  "自分のための時間を大切にしたい方",
  "自然の中でリフレッシュしたい方",
  "出産後のお体のケアをしたい方",
  "更年期の不調を和らげたい方",
  "年に数回、本当に良いケアをしたい方",
];

export default function TargetAudience() {
  return (
    <section className="py-24 bg-[#f2ede3]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="aspect-[4/5] rounded-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/98c8f721efe8e85064ec351cb642a7fc/d5c15a57fbe3fb390411a80c53a91cf1.png"
                alt="来てほしい方"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div>
            <p className="text-[#3a4a28]/50 text-xs tracking-[0.4em] mb-6">FOR YOU</p>
            <h2 className="font-serif text-3xl md:text-4xl text-[#2a2a1e] leading-tight mb-10">
              こんな方に、<br />来てほしい。
            </h2>
            <ul className="space-y-4">
              {targets.map((target, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <div className="w-1.5 h-1.5 bg-[#3a4a28] rounded-full" />
                  </div>
                  <span className="text-[#3a3a2a] text-sm leading-relaxed tracking-wide">
                    {target}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
